import { render, staticRenderFns } from "./OnboardingSelfieFaceTecCamera.vue?vue&type=template&id=968072e8"
import script from "./OnboardingSelfieFaceTecCamera.vue?vue&type=script&lang=js"
export * from "./OnboardingSelfieFaceTecCamera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports